import { PagedRequestDto } from '../paged-request.model';
export interface CorporatePositionsParameters extends PagedRequestDto {
  corporationId?: string;
  isActive?: boolean;
  isProtected?: boolean;
}
